document.addEventListener('DOMContentLoaded', function () {
  const check = document.getElementById('grabado-check');
  const campo = document.getElementById('grabado-campo');
  const texto = document.getElementById('grabado-texto');
  const oculto = document.getElementById('grabado-hidden');

  if (!check || !campo || !texto || !oculto) return;

  campo.style.display = check.checked ? 'block' : 'none';

  check.addEventListener('change', function () {
    campo.style.display = this.checked ? 'block' : 'none';

    if (!this.checked) {
      texto.value = '';
      oculto.value = '';
    }
  });

  texto.addEventListener('input', function () {
    oculto.value = this.value;
  });

  document.querySelector('form[action="/cart/add"]')?.addEventListener('submit', function () {
    oculto.value = check.checked ? texto.value : '';
  });
});
